import React, { useEffect, useState, } from "react";
import { useTranslation } from "react-i18next";

import Base from '../utils/base'

const Navbar = (props) => {
	var base = new Base()
	const {t, i18n} = useTranslation()

	const [phone, setPhone] = useState('')
	const [email, setEmail] = useState('')
	const [address, setAddress] = useState('')
	const [facebook, setFacebook] = useState('')
	const [tiktok, setTiktok] = useState('')
	const [instagram, setInstagram] = useState('')
	const [wa, setWa] = useState('')

	useEffect(() => {
		var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

		get_info_data()

		setTimeout(() => {
			window.$('.mobile-nav__btn').click(function(e) {
				setMenuClicked()
			})
			
		}, 6000)
	}, [])

	function setMenuClicked(){
		window.$(".mobile-nav__wrapper").addClass("expanded");
	}
	
	async function get_info_data() {
		var response = await base.request(base.url_api + "/setting")

		if(response != null){
			if(response.status == "success"){
				for(let data of response.data){
					if(data.key == 'phone')
						setPhone(data.value)
					else if(data.key == 'address')
						setAddress(data.value)
					else if(data.key == 'email')
						setEmail(data.value)
					else if(data.key == 'facebook')
						setFacebook(data.value)
					else if(data.key == 'tiktok')
						setTiktok(data.value)
					else if(data.key == 'instagram')
						setInstagram(data.value)
					else if(data.key == 'wa_link')
						setWa(data.value)
				}
				
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

	return (
		<>
			<div className="topbar-three">
				<div className="container">
					<div className="topbar-three__inner">
						<div className="topbar-three__inner__left">
							<ul className="list-unstyled topbar-three__info">
								<li className="topbar-three__info__item">
									<div className="topbar-three__info__icon">
										<i className="icon-pin"></i>
									</div>

									<p className="topbar-three__info__location" style={{ fontSize: '.8rem', }}>{address}</p>
								</li>

								<li className="topbar-three__info__item">
									<div className="topbar-three__info__icon">
										<i className="icon-envelope"></i>
									</div>

									<a href={"mailto:" + email} className="topbar-three__info__contact" style={{ fontSize: '.8rem', }}>{email}</a>
								</li>

								<li className="topbar-three__info__item">
									<div className="topbar-three__info__icon">
										<i className="icon-call"></i>
									</div>

									<a href={"tel:" + phone} className="topbar-three__info__contact" style={{ fontSize: '.8rem', }}>{phone}</a>
								</li>
							</ul>
						</div>
						<div className="topbar-three__inner__right p-0">
							{/* <ul className="list-unstyled topbar-three__item">
								<li><a href="blog-details.html" className="topbar-three__item__text">Explore Solinom</a></li>
								<li><a href="faq.html" className="topbar-three__item__text">FAQs</a></li>
								<li><a href="about.html" className="topbar-three__item__text">About</a></li>
							</ul> */}
							<div className="topbar-three__social m-0 d-flex">
								<a target="_blank" href={facebook}> <i class="fa-brands fa-facebook"></i> <span className="sr-only">Facebook</span></a>
								<a target="_blank" href={wa}> <i class="fa-brands fa-whatsapp"></i> <span className="sr-only">Twitter</span></a>
								<a target="_blank" href={instagram}> <i class="fa-brands fa-instagram"></i> <span className="sr-only">youtube</span></a>
								<a target="_blank" href={tiktok}> <i class="fa-brands fa-tiktok"></i> <span className="sr-only">Tiktok</span></a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<header className="main-header main-header--three sticky-header sticky-header--normal">
				<div className="container">
					<div className="main-header__inner">
						<div className="main-header__logo">
							<a href="/">
								<img src="/img/Mooz_Logo.png" alt="Solinom HTML" width="80" height="66" />
							</a>
						</div>

						<nav className="main-header__nav main-menu">
							<ul className="main-menu__list">

								<li className="">
									<a href="/" style={{ fontSize: '1rem', }}>{t('navbar.home')}</a>
									{/* <ul>
										<li>
											<section className="home-showcase">
												<div className="container">
													<div className="home-showcase__inner">
														<div className="row">
															<div className="col-md-6 col-lg-3">
																<div className="demo-one__card">
																	<div className="demo-one__image">
																		<img src="assets/images/home-showcase/home-showcase-1.jpg" alt="solinom" />
																		<div className="demo-one__btns">
																			<a href="index.html" className="solinom-btn demo-one__btn">Multi Page</a>
																			<a href="index-one-page.html" className="solinom-btn demo-one__btn">One Page</a>
																		</div>
																	</div>
																	<div className="demo-one__content">
																		<h3 className="demo-one__title">
																			<a href="index.html">Home Page 01</a>
																		</h3>
																	</div>
																</div>
															</div>
															<div className="col-md-6 col-lg-3">
																<div className="demo-one__card">
																	<div className="demo-one__image">
																		<img src="assets/images/home-showcase/home-showcase-2.jpg" alt="solinom" />
																		<div className="demo-one__btns">
																			<a href="index-2.html" className="solinom-btn demo-one__btn">Multi Page</a>
																			<a href="index-2-one-page.html" className="solinom-btn demo-one__btn">One Page</a>
																		</div>
																	</div>
																	<div className="demo-one__content">
																		<h3 className="demo-one__title">
																			<a href="index-2.html">Home Page 02</a>
																		</h3>
																	</div>
																</div>
															</div>
															<div className="col-md-6 col-lg-3">
																<div className="demo-one__card">
																	<div className="demo-one__image">
																		<img src="assets/images/home-showcase/home-showcase-3.jpg" alt="solinom" />
																		<div className="demo-one__btns">
																			<a href="index-3.html" className="solinom-btn demo-one__btn">Multi Page</a>
																			<a href="index-3-one-page.html" className="solinom-btn demo-one__btn">One Page</a>
																		</div>
																	</div>
																	<div className="demo-one__content">
																		<h3 className="demo-one__title">
																			<a href="index-3.html">Home Page 03</a>
																		</h3>
																	</div>
																</div>
															</div>
															<div className="col-md-6 col-lg-3">
																<div className="demo-one__card">
																	<div className="demo-one__image">
																		<img src="assets/images/home-showcase/home-showcase-4.jpg" alt="solinom" />
																		<div className="demo-one__btns">
																			<a href="index-4.html" className="solinom-btn demo-one__btn">Multi Page</a>
																			<a href="index-4-one-page.html" className="solinom-btn demo-one__btn">One Page</a>
																		</div>
																	</div>
																	<div className="demo-one__content">
																		<h3 className="demo-one__title">
																			<a href="index-4.html">Home Page 04</a>
																		</h3>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</section>
										</li>
									</ul> */}
								</li>
								<li>
									<a href="/rooms" style={{ fontSize: '1rem', }}>{t('navbar.rooms')}</a>
									{/* <ul className="sub-menu">
										<li className="dropdown">
											<a href="/rooms">Room</a>
											<ul className="sub-menu">
												<li><a href="/rooms">Room</a></li>
												<li><a href="room-grid.html">Room Grid</a></li>
												<li><a href="room-carousel.html">Room Carousel</a></li>
												<li><a href="room-sidebar-left.html">Left Sidebar</a></li>
												<li><a href="room-sidebar-right.html">Right Sidebar</a></li>
											</ul>
										</li>
										<li className="dropdown">
											<a href="room-list.html">Room List</a>
											<ul className="sub-menu">
												<li><a href="room-list.html">Room List</a></li>
												<li><a href="room-list-left.html">Left Sidebar</a></li>
												<li><a href="room-list-right.html">Right Sidebar</a></li>
												<li><a href="room-list-carousel.html">Carousel</a></li>
											</ul>
										</li>
										<li className="dropdown">
											<a href="room-2.html">Room two</a>
											<ul className="sub-menu">
												<li><a href="room-2.html">Room two</a></li>
												<li><a href="room-2-grid.html">Room two Grid</a></li>
												<li><a href="room-2-sidebar-left.html">Left Sidebar</a></li>
												<li><a href="room-2-sidebar-right.html">Right Sidebar</a></li>
												<li><a href="room-2-carousel.html">Carousel</a></li>
											</ul>
										</li>
										<li><a href="top-search.html">Top Search</a></li>
										<li><a href="deluxe-room-details.html">Deluxe Room Details</a></li>
										<li><a href="room-details-2.html">Room Details Two</a></li>
										<li><a href="room-details-3.html">Room Details Three</a></li>
									</ul> */}
								</li>
								<li>
									<a href="/facility" style={{ fontSize: '1rem', }}>{t('navbar.facility')}</a>
								</li>
								<li>
									<a href="/gallery" style={{ fontSize: '1rem', }}>{t('navbar.gallery')}</a>
								</li>
							</ul>
						</nav>
						<div className="main-header__right align-items-center justify-content-center px-4" style={{ gap: '15px', }}>
							<div className="main-header__right__call">
								<div className="main-header__right__call__icon">
									<i className="icon-phone"></i>
								</div>
								<div className="main-header__right__call__content">
									<span className="main-header__right__call__subtitle" style={{ fontSize: '.8rem', }}>{t('navbar.call_anytime')}</span>
									<a href={"tel:" + phone} className="main-header__right__call__title" style={{ fontSize: '1rem', }}>{phone}</a>
								</div>
							</div>
							<a href={"tel:" + phone} className="solinom-btn main-header__btn" style={{ fontSize: '.8rem', }}>{t('navbar.book_hotel')}</a>

							<div className="mobile-nav__btn mobile-nav__toggler m-0">
								<span></span>
								<span></span>
								<span></span>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default Navbar;
